<template>
  <div class="bg-white h-100">
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <b-list-group flush v-if="documentViewers">
      <b-list-group-item
        v-for="viewer in documentViewers"
        :key="viewer.id"
      >
        <i
          style="font-size: 20px"
          class="mr-2 mdi"
          :class="`mdi-${viewer.icon}`"
        />
        <span class="flex-grow-1">
          {{ viewer.name }}
        </span>
      </b-list-group-item>
    </b-list-group>
    <LmSvgIcon
      v-else
      wrapperClass="d-flex mt-5 justify-content-center align-items-center flex-column"
      width="6em"
      icon="LmNoDataIcon"
      text="Este documento no posee visualizadores."
    />
  </div>
</template>

<script>
export default {
  props: {
    viewers: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    documentViewers () {
      let viewers = []
      for (const key in this.viewers) {
        viewers = viewers.concat(this.viewers[key].map(r => {
          return {
            ...r,
            icon: this.setIcon(key)
          }
        }))
      }
      return viewers.length ? viewers : null
    }
  },
  methods: {
    setIcon (type) {
      const icons = {
        users: 'account',
        areas: 'domain',
        subareas: 'account-group',
        mesas: 'account-multiple',
        emails: 'at'
      }
      return icons[type]
    }
  }
}
</script>
